<template>
  <div>
    <div class="d-flex align-items-center">
      <div style="background: #CFAD6C;border-radius: 50px;width: 9px; height: 2px;margin-left: 1px"></div>
      <div style="background: #CFAD6C;border-radius: 50px;width: 2px; height: 2px;margin-left: 3px"></div>
      <div class="headerStyle">جزییات پرداخت</div>
      <div style="background: #CFAD6C;border-radius: 50px;width: 27px; height: 2px;margin-right: 3px"></div>
      <div style="background: #CFAD6C;border-radius: 50px;width: 2px; height: 2px;margin-right: 1px"></div>
    </div>
    <b-row class="sectionStyle">
      <b-col lg="3" md="6" cols="12" class="items">
        <div class="rightContent">مبلغ کل کالا ها :</div>
        <div class="leftContent">{{ paymentData.productsTotalPrice }} تومان</div>
      </b-col>
      <b-col lg="3" md="6" cols="12" class="items">
        <div class="rightContent">هزینه ارسال :</div>
        <div class="leftContent">{{ paymentData.shippingCost }} تومان</div>
      </b-col>
      <b-col lg="3" md="6" cols="12" class="items">
        <div class="rightContent">تخفیف :</div>
        <div class="leftContent">{{ paymentData.totalDiscount }} تومان</div>
      </b-col>
      <b-col lg="3" md="6" cols="12" class="items">
        <div class="rightContent">مبلغ پس از تخفیف :</div>
        <div class="leftContent">{{ paymentData.totalPriceAfterDiscount }} تومان</div>
      </b-col>
    </b-row>
    <div class="d-flex justify-content-end">
      <div class="buttonStyle">
        <!-- <div class="d-flex align-items-center justify-content-between" style="width: 47%;padding-right: 20px;"> -->
        <div class="totalStyle">جمع</div>
        <div class="d-flex align-items-center">
          <div class="totalNumberStyle">{{ paymentData.totalPriceAfterDiscountAndTaxAndShippingCost }}</div>
          <div style="totalNumberToman">تومان</div>
        </div>
      </div>
      <!-- <div class="w-50">
          <button class="buttonCss">پرداخت</button>
        </div> -->
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    paymentData: {
      default: null,
    },
  },
}
</script>

<style scoped lang="scss">
.headerStyle {
  color: #414141;
  font-size: 18px;
}
.sectionStyle {
  margin: 22px 0;
}
.items {
  display: flex;
}
.rightContent {
  font-size: 16px;
  color: #979797;
  margin-left: 5px;
}
.leftContent {
  font-size: 16px;
  color: #4a4a4a;
}
.buttonStyle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(231, 211, 140, 0.17);
  border-radius: 8px;
  width: 40%;
  padding: 0 15px;
  height: 50px;
}
.buttonCss {
  background: #ffffff;
  border: 1px solid #cfad6c;
  color: #cfad6c;
  font-size: 18px;
  border-radius: 8px;
  width: 100%;
  height: 100%;
}
.totalStyle {
  color: #4a4a4a;
  font-size: 18px;
}
.totalNumberStyle {
  font-size: 18px;
  margin-left: 5px;
}
.totalNumberToman {
  font-size: 16px;
}
@media only screen and (max-width: 768px) {
  .headerStyle {
    font-size: 16px;
  }
  .rightContent {
    font-size: 14px;
  }
  .leftContent {
    font-size: 14px;
  }
  .buttonStyle {
    width: 70%;
  }
  .buttonCss {
    font-size: 16px;
  }
  .totalStyle {
    font-size: 16px;
  }
  .totalNumberStyle {
    font-size: 16px;
    margin-left: 5px;
  }
  .totalNumberToman {
    font-size: 14px;
  }
}
@media only screen and (max-width: 576px) {
  .headerStyle {
    font-size: 14px;
  }
  .rightContent {
    font-size: 12px;
  }
  .leftContent {
    font-size: 12px;
  }
  .buttonStyle {
    width: 100%;
  }
  .buttonCss {
    font-size: 12px;
  }
  .totalStyle {
    font-size: 12px;
  }
  .totalNumberStyle {
    font-size: 12px;
  }
  .totalNumberToman {
    font-size: 13px;
  }
}
</style>
